import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import 'intl-pluralrules'

import ar from '@dentolize/clinic-mobile/src/shared/i18n/translations/ar.json'
import en from '@dentolize/clinic-mobile/src/shared/i18n/translations/en.json'
import fr from '@dentolize/clinic-mobile/src/shared/i18n/translations/fr.json'
import it from '@dentolize/clinic-mobile/src/shared/i18n/translations/it.json'
import nl from '@dentolize/clinic-mobile/src/shared/i18n/translations/nl.json'
import el from '@dentolize/clinic-mobile/src/shared/i18n/translations/el.json'
import pl from '@dentolize/clinic-mobile/src/shared/i18n/translations/pl.json'
import ku from '@dentolize/clinic-mobile/src/shared/i18n/translations/ku.json'
import ckb from '@dentolize/clinic-mobile/src/shared/i18n/translations/ckb.json'

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  debug: false,
  resources: {
    ar,
    en,
    fr,
    it,
    nl,
    el,
    pl,
    ku,
    ckb
  }
})

export default i18n
